import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService.js';
import { wsGetAll } from 'services/WService';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [coverages, setCoverages] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listCoverage() {
    let response = await wsGetAll('sale/cobertura-colgate');
    if (response.success) setCoverages(response.data);
  }
  useEffect(() => {
      if (customerPortfolioB.open) {
        if (!customerPortfolioB.id) listCoverage();
        setDataChanging(customerPortfolioB);
      }
    }, [customerPortfolioB.open]);

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return { description: item.DESCRIPCION };
        }),
        description: dataImport.nameFile
      });
    } else if (dataImport?.success === false) {
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.id) {
      setDataImport({});
    }
  }, [bPartnerSelect]);

  return (
    <>
      <Modal
        title={`Nuevo periodo`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/periodo-colgate'
        dataForce={{
          id_cobertura: dataChanging.id_cobertura,
          Periodo: dataChanging.Periodo,
        }}
      >
        <Autocomplete
          disableClearable
          options={coverages}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Coberturas bimestrales" margin="normal" required />
          )}
          onChange={(e, item) => handleChange('id_cobertura', item?.id)}
          value={coverages.find(coverage => coverage.id === dataChanging.id_cobertura) || null}
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <TextField
            label="Periodo"
            type="number"
            // value={dataChanging.Periodo || null}
            margin="normal"
            name="periodo"
            required
            fullWidth
          />
        </span>
      </Modal>
    </>
  );
});
